import type {BlobLayoutStyledBlobPayload} from '@github-ui/code-view-types'
import React from 'react'

interface StyledBlobContextValue extends BlobLayoutStyledBlobPayload {
  isLoading: boolean
}

const CurrentStyledBlobContext = React.createContext({} as StyledBlobContextValue)

const defaultBlob: BlobLayoutStyledBlobPayload = {
  colorizedLines: null,
  rawLines: null,
  stylingDirectives: undefined,
}

export function CurrentStyledBlobProvider({
  blob,
  isLoading,
  children,
}: React.PropsWithChildren<{blob?: BlobLayoutStyledBlobPayload; isLoading?: boolean}>) {
  const value = React.useMemo(() => ({...(blob ?? defaultBlob), isLoading: isLoading ?? false}), [blob, isLoading])
  return <CurrentStyledBlobContext value={value}> {children} </CurrentStyledBlobContext>
}

export function useCurrentStyledBlob() {
  return React.use(CurrentStyledBlobContext)
}
